import "./index.css";
import { PaywallBuilder } from "./PaywallBuilder";

export function App() {
  return <PaywallBuilder />;
}

export default App;
